import styled from 'styled-components';
import { Flex } from 'reflexbox';

import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { ButtonSize } from 'packages/kakapo-ui-kit/types/Button';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import {
	PrimaryButtonAnchor,
	PrimaryButtonLink,
} from 'packages/kakapo-ui-kit/components/buttons/PrimaryButton';
import URLService from 'packages/kakapo-ui-services/services/common/URLService';

const Element = styled.div`
	img {
		width: 600px;
		max-width: 100%;
	}

	video {
		width: 350px;
		max-width: 100%;
	}
`;

interface IProps {
	title: string;
	buttonTitle?: string;
	contentMarginTop?: number;
	contentMarginBottom?: number;
	imageSrc?: string;
	videoSrc?: string;
	to?: string;
	onClick?: () => void;
}

export default function ThankYouModal({
	title,
	buttonTitle,
	contentMarginTop = 2,
	contentMarginBottom = 2,
	imageSrc,
	videoSrc,
	to,
	onClick,
}: IProps) {
	const usesAnchor = to == null || URLService.isExternalLink(to);

	return (
		<Element>
			<Flex alignItems="center" flexDirection="column">
				<Column mt={contentMarginTop} mb={contentMarginBottom}>
					{imageSrc && <img src={imageSrc} alt={title} />}
					{videoSrc && (
						<>
							{/* eslint-disable-next-line jsx-a11y/media-has-caption */}
							<video autoPlay loop>
								<source src={videoSrc} type="video/webm" />
							</video>
						</>
					)}
				</Column>
				<Column p={3} textAlign="center">
					<SectionTitle>{title}</SectionTitle>
				</Column>

				{buttonTitle && (
					<Column py={2}>
						{usesAnchor !== true ? (
							<PrimaryButtonLink size={ButtonSize.Medium} to={to!}>
								{buttonTitle}
							</PrimaryButtonLink>
						) : (
							<PrimaryButtonAnchor size={ButtonSize.Medium} onClick={onClick} href={to}>
								{buttonTitle}
							</PrimaryButtonAnchor>
						)}
					</Column>
				)}
			</Flex>
		</Element>
	);
}
